var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy1St(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V4C0 6.06548 1.60369 8 4.14142 8C4.48578 9.32947 5.49066 10.3786 6.79016 10.7935C6.612 11.7306 6.28198 12.9044 5.66724 14H4V16H12V14H10.3328C9.71802 12.9044 9.388 11.7306 9.20984 10.7935C10.5093 10.3786 11.5142 9.32947 11.8586 8C14.3879 8 16 6.07178 16 4V0H0ZM2 4V2H4V6C2.89746 6 2 5.10303 2 4ZM14 4C14 5.10303 13.1025 6 12 6V2H14V4Z",
    fill: "#FF9400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy1St);
export default __webpack_public_path__ + "static/media/trophy-1st.55a56912e2cd0cc2771bf7fc1cd16112.svg";
export { ForwardRef as ReactComponent };